const ObjectType = {
  Value: "value",
  Text: "text",
  Inline: "inline",
  Block: "block",
  Document: "document",
  Leaf: "leaf",
  Selection: "selection",
  Mark: "mark",
  Range: "range",
  Decoration: "decoration",
  Annotation: "annotation",
  Point: "point",
  Operation: "operation"
};
export {
  ObjectType
};
//# sourceMappingURL=types.js.map